module.exports = __webpack_public_path__ + "img/Z81_02.f0aad786.jpg";